import React, { PureComponent } from 'react';
import axios from 'axios';
import { Row, Col } from 'react-bootstrap';
import Pagination from "react-js-pagination";
import LinksRowTable from './linksList/linksRowTable';
import ModalComponent from '../../components/complex/modalComponent';
import LinkEditModal from './linksList/linkEditModal';
import LinkHideModal from './linksList/linkHideModal';
import LinkDeleteModal from './linksList/linkDeleteModal';
import appConstant from '../../../constants/app';
import actionsConstant from '../../../constants/actions';

class LinksList extends PureComponent {
  state = {
    links: [],
    totalItems: null,
    isActive: false,
    body: '',
    activePage: 1,
    itemsCountPerPage: 15,
    pageRangeDisplayed: 5,
    isLoaderOpened: false,
    showPagination: false,
    orderByClicks: '',
  }

  componentDidMount () {
    this.props.onRef(this);
    this.fetch(1);
  }

  componentWillUnmount() {
    this.props.onRef(undefined);
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevProps.keyword !== this.props.keyword) {
      this.setState({activePage: 1});
      this.fetchSearch(this.props.keyword, 1);
    }
  }
  
  fetch = (page) => {
    this.setState({ isLoaderOpened: true });

    const {orderByClicks} = this.state;

    let url = `${appConstant.API_URL}/link?page=${page}&access_token=${localStorage.getItem('token')}&orderByClicks=${orderByClicks}`;
    axios.get(url)
      .then(res => {
        const totalItems = res.data.totalItems;
        const links = res.data.links;
        const showPagination = (totalItems > this.state.itemsCountPerPage);
        this.setState({
          links,
          totalItems,
          showPagination,
        });

        this.setState({ isLoaderOpened: false });
        this.props.updateSearchBar();
      }).catch(err => {
        console.log(err);
      });
  }

  fetchSearch = (key, page) => {
    let url = `${appConstant.API_URL}/link/search?key=${key}&page=${page}`;
    axios.get(url)
      .then(res => {
        this.setState({links: []});
        const totalItems = res.data.totalItems;
        const links = res.data.links;
        const showPagination = (totalItems > this.state.itemsCountPerPage);
        this.setState({
          links,
          totalItems,
          showPagination,
        });
      }).catch(err => {
        const links = [];
        this.setState({
          links,
        });
      });
  }

  onToggleModal = () => {
    this.setState(prevState => ({ isActive: !prevState.isActive }));
  }

  onAccept = () => {
    this.fetch(1);
    this.setState({ activePage: 1 });
  }

  linkHideOrShow = (id) => {
    const token = localStorage.getItem('token');

    // This should be in a service folder, not in component
    axios({
      method: 'post',
      url: `${appConstant.API_URL}/link/hide?access_token=${token}`, 
      data: { id },
    }).then(res => {
      this.onAccept();
    }).catch(err => {
      console.log(err);
    });
  }

  onHandleModal = (id, label, hidden, action) => {
    this.setState({id});
    
    // This is only for hide/show action
    if(action === actionsConstant.hide) {
      this.linkHideOrShow(id)
      return;
    }

    this.onToggleModal();

    if(action === actionsConstant.edit) {
      this.setState({
        body: <LinkEditModal
          linkId={id}
          onClose={this.onToggleModal}
          onAccept={this.onAccept}
        />,
        title: 'Edit link',
      });
    } else if(action === actionsConstant.hide) {
      this.setState({
        body: <LinkHideModal
          id={id}
          label={label}
          onClose={this.onToggleModal}
          hidden={hidden}
          onAccept={this.onAccept}
        />,
        title: `Are you sure you want to ${hidden === 0 ? 'hide' : 'show' } this link?`,
      });
    } else if(action === actionsConstant.delete) {
      this.setState({
        body: <LinkDeleteModal
          id={id}
          label={label}
          onClose={this.onToggleModal}
          onAccept={this.onAccept}
        />,
        title: 'Are you sure you want to delete this link?',
      });
    }
  }

  handlePageChange = (pageNumber) => {
    this.setState({activePage: pageNumber});
    if(this.props.keyword) {
      this.fetchSearch(this.props.keyword, pageNumber);
    } else {
      this.fetch(pageNumber);
    }
  }

  handleOrderByClicks = () => {
    this.setState(prevState => ({
      orderByClicks: !prevState.orderByClicks
    }), () => {
      this.fetch(1)
    });
  }

  render () {
    const {
      links,
      isActive,
      body,
      title,
      totalItems,
      itemsCountPerPage,
      pageRangeDisplayed,
      isLoaderOpened,
      showPagination,
    } = this.state;

    return (
      <div>
        <Row>
          <Col sm={12}>
          {
            isLoaderOpened
            ? <p> Loading... </p>
            : <LinksRowTable
              links={links}
              showModalHandle={this.onHandleModal}
              orderByClicks={this.handleOrderByClicks}
              orderDirection={this.state.orderByClicks}
            />
          }
          </Col>
        </Row>
        {
          showPagination
          ?
          <Row>
            <Col
              className="pagination-container"
              sm={12
            }>
              <Pagination
                activePage={this.state.activePage}
                totalItemsCount={totalItems}
                itemsCountPerPage={itemsCountPerPage}
                pageRangeDisplayed={pageRangeDisplayed}
                onChange={this.handlePageChange}
              />
            </Col>
          </Row>
          :
          <Row>
          </Row>
        }
        <ModalComponent
          isActive={isActive}
          onClose={this.onToggleModal}
          title={title}
          body={body}
        />
      </div>
    );
  }
}

export default LinksList;


// WEBPACK FOOTER //
// ./src/app/screens/links/linksList.js